import { defineStore } from 'pinia'
import { userInfo } from "@/api"
import { showConfirmDialog } from "vant"
import router from '@/router'

export const useMainStore = defineStore('main', {
  state: () => ({
    token: '',
  }),
  actions: {
    setToken(token: string) {
      this.token = token
    },
  },
  persist: {
    enabled: true,
    key: 'H5-main-key-store',
    storage: localStorage,
    pick: ['token']
  }
})
